'use strict';

angular.module('atex.art').factory('ArtGenericStore',
['$q', '$rootScope',

  function($q, $rootScope) {
    return atex.GenericStore(atex.act.AngularUtils.applyingQ($q, $rootScope));
  }
]);
